'use strict';

var GridDuplicateRowButtonDirective = function GridDuplicateRowButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-duplicate-row-button.html'),
    controller: 'GridDuplicateRowButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowIndexes) {
        $scope.onRowSelection(selectedRows, selectedRowIndexes);
      });
    }
  };
};
GridDuplicateRowButtonDirective.$inject = [];
module.exports = GridDuplicateRowButtonDirective;